module.exports = function () { /* empty */ };



//////////////////
// WEBPACK FOOTER
// ./~/.pnpm/core-js@2.6.12/~/core-js/library/modules/_add-to-unscopables.js
// module id = 129
// module chunks = 1 2 3